export const EVTBUS_KEY_DISPLAY_FEEDBACK = "display-feedback-window-on-first";
export const EVTBUS_KEY_UPDATE_CREDITS = "update-credits";
